import React from 'react'
import { Avatar } from '@mui/material'
import Button from '@mui/material/Button'
import { UserInterface } from '@/services/types/APIResponseType'
import { formatPhoneNumber, stringAvatar } from '@/utils'

interface ConsumerTablePropsType {
  consumersData: UserInterface[]
  handleOpen: (selectedConsumer: UserInterface) => void
  handleViewDetails: (consumerId: string) => void
}

const ConsumerTable: React.FC<ConsumerTablePropsType> = ({
  consumersData,
  handleOpen,
  handleViewDetails,
}) => {
  return (
    <>
      {consumersData && consumersData.length > 0 && (
        <div className="max-w-full overflow-auto">
          <table className="table-container bg-grad before:rounded-[20px] rounded-[20px]">
            <thead>
              <tr className="table-heading row-bg1">
                <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                  Name
                </th>
                <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                  Phone Number
                </th>
                <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                  Email Address
                </th>
                <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                  Govt. ID
                </th>
                <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {consumersData &&
                consumersData?.map((item: UserInterface, idx: number) => (
                  <tr
                    key={idx}
                    className={idx % 2 === 0 ? 'rowbg2' : 'row-bg1'}
                  >
                    <td className="text-left border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                      <div className="profile-cell">
                        {item?.profileInfo?.profilePic ? (
                          <img
                            alt="Profile"
                            src={item.profileInfo?.profilePic}
                            className="consumer-avatar"
                          />
                        ) : (
                          <Avatar
                            className="!bg-[#365F91] mr-4"
                            {...stringAvatar(
                              `${item?.profileInfo?.firstName} ${item?.profileInfo?.lastName}`,
                            )}
                          />
                        )}
                        <span className="flex-1 min-w-0 max-w-[160px] break-words whitespace-normal text-left">
                          {item?.profileInfo?.firstName}&nbsp;
                          {item?.profileInfo?.lastName}
                        </span>
                      </div>
                    </td>
                    <td className="text-left border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                      {formatPhoneNumber(
                        item?.profileInfo?.phone,
                        item?.profileInfo?.countryCode,
                      )}
                    </td>
                    <td className="text-left border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                      {item?.email}
                    </td>
                    <td className="min-w-36 border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                      <label
                        className="view-id"
                        onClick={() => handleOpen(item)}
                      >
                        View ID
                      </label>
                    </td>
                    <td className="border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                      <Button
                        onClick={() =>
                          handleViewDetails(item.profileInfo?.userId)
                        }
                      >
                        <img src="/icon/eye icon.png" alt="watch" />
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}

export default ConsumerTable
